<template>
    <div>
        <div
            class="salepage-product__cart tw-flex tw-justify-center"
            v-if="isOpen"
        >
            <div
                class="salepage-product__cart--shade"
                @click="closeModal()"
            ></div>
            <div
                id="cart-body"
                class="salepage-product__cart--body tw-w-full md:tw-w-6/12 lg:tw-w-4/12"
                :style="cartModalOpen ? 'transform: translateX(0);' : ''"
            >
                <div
                    class="salepage-product__cart--modal-header tw-flex tw-justify-between border-section tw-pt-5 tw-mx-6 tw-pb-4 tw-rounded-2xl tw-rounded-b-none"
                    width="100%"
                >
                    <div class="tw-text-xl tw-text-bold">
                        {{ title }}
                    </div>
                    <div class="btn text-2xl tw-px-2 tw-py-1 tw-rounded-lg salepage-product__cart--close-button" :style="styleObject"
                        @click="closeModal()">
                    <i class="fa fa-close"></i>

                    </div>
                </div>
                <div class="tw-mx-6 tw-mt-4 overflow-auto items-table">
                    <slot name="item-table"></slot>
                </div>
                <div class="tw-mx-6 overflow-auto">
                    <slot name="total-price"></slot>
                </div>
                <div class="tw-flex tw-justify-center tw-mt-4 tw-px-6">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["isOpen", "title", "salePage"],
    data() {
        return {
            cartModalOpen: false
        };
    },
    methods: {
        closeModal() {
            this.cartModalOpen = false;
            setTimeout(() => {
                this.$emit("closeModal");
            }, 400);
        }
    },
    watch: {
        isOpen: function(value) {
            if (value) {
                setTimeout(() => {
                    this.cartModalOpen = true;
                }, 100);
            }
        }
    },
    computed: {
        styleObject: function () {
            return {
                '--button-color': this.salePage.button_color,
                '--button-text': this.salePage.button_text
            }
        }
    },
};
</script>
<style scoped>

input {
    border: 0;
    outline: 0;
    width: 70%;
    text-align: center;
}

input:focus {
    outline: none!important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.salepage-product__cart--close-button {
    border: 1px solid var(--button-color);
}

.salepage-product__cart--close-button:hover {
    background-color: var(--button-color);
    color: var(--button-text);
}
.border-section {
    border-bottom: 2px solid #dedede;
}

.quantity-selector {
    border: 1px solid var(--button-color);
}
.salepage-product__cart {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 9997;
}
.salepage-product__cart--shade {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
    z-index: 9998;
}
.salepage-product__cart--body {
    position: absolute;
    opacity: 100%;
    right: 0;
    background-color: #fff;
    height: 100%;
    z-index: 9999;
    transition: all 0.5s ease;
    transform: translateX(100%);
}

.shadow-overlay:hover {
    box-shadow: inset 0 0 0 20000px rgba(0, 0, 0, 0.25);
    transition: all 0.25s ease;
}

.items-table {
    height: 70%;
    overflow-y: auto;
}
</style>
